<template>
    <div>
        <div class="row mt-2">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Código Postal</label>
                    <input v-model="local.codigoPostal" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-1">
                <div class="form-group">
                    <label class="control-label d-block invisible">Buscar</label>
                    <button type="button" class="btn btn-primary btn-sm" @click="onSearchCP">
                        <vue-feather type="search" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div class="col-md-7">
                <div class="form-group">
                    <label class="control-label">* Estado</label>
                    <input v-model="local.estado" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">* Municipio</label>
                    <input v-model="local.municipio" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Colonia</label>
                    <input v-model="local.colonia" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">* Calle</label>
                    <input v-model="local.calle" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">* Número exterior</label>
                    <input v-model="local.numeroExt" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Número interior</label>
                    <input v-model="local.numeroInt" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Ciudad</label>
                    <input v-model="local.ciudad" :disabled="local.disabledCP" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/axios';

const emptyDireccion = () => ({
    tipoId: null,
    codigoPostal: '',
    codigoPostalId: null,
    estado: '',
    estadoId: null,
    municipio: '',
    municipioId: null,
    colonia: '',
    calle: '',
    ciudad: '',
    paisId: 1,
    numeroExt: '',
    numeroInt: '',
    disabledCP: 1,
});

export default {
    name: 'FormDireccion',

    props: {
        modelValue: {
            type: Object,
            default: () => emptyDireccion(),
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            local: {
                ...emptyDireccion(),
                ...this.modelValue,
                numeroExt: this.modelValue?.numeroExt ?? '',
                numeroInt: this.modelValue?.numeroInt ?? '',
            },
        };
    },

    watch: {
        modelValue(val) {
            if (JSON.stringify(val) !== JSON.stringify(this.local)) {
                this.local = {
                    ...emptyDireccion(),
                    ...val,
                    numeroExt: val?.numeroExt ?? '',
                    numeroInt: val?.numeroInt ?? '',
                };
            }
        },
        local: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', { ...val });
            },
        },
    },

    methods: {
        async onSearchCP() {
            try {
                const response = await api.get(`codigospostales/porcodigo/${this.local.codigoPostal}`);
                if (response.status === 200) {
                    this.local.codigoPostalId = response.data.id ?? null;
                    this.local.estado = response.data.municipios.estados.nombre;
                    this.local.estadoId = response.data.municipios.estados.id ?? null;
                    this.local.municipio = response.data.municipios.nombre;
                    this.local.municipioId = response.data.municipios.id ?? null;
                    this.local.paisId = 1;
                    this.local.colonia = response.data.nombreAsentamiento;
                    this.local.ciudad = response.data.ciudades.nombre;
                    this.local.disabledCP = 0;
                }
            } catch {
                this.local.estado = '';
                this.local.estadoId = null;
                this.local.municipio = '';
                this.local.municipioId = null;
                this.local.paisId = 1;
                this.local.colonia = '';
                this.local.ciudad = '';
                this.local.disabledCP = 0;
            }
        },
    },
};
</script>
